import {Routes, BrowserRouter, Route, Navigate} from 'react-router-dom'
import { routes } from './routes';
import PrivateWrapper from './PrivateRoutes';
import LoginLayout from '../layout/LoginLayout';
import { AdminRole, AppRoutes } from '../types/constants.types';
import RequestLoginPage from '../pages/Auth/RequestLoginPage';
import LoginPage from '../pages/Auth/LoginPage';
import ForgotPasswordPage from '../pages/Auth/ForgotPasswordPage';
import DashboardLayout from '../layout/DashboardLayout';
import { useSelector } from 'react-redux';
import { RootState } from '../state/store';
import { canAccessByRole } from '../lib/constants/navigation';
import { canAccessWebsiteCms, isWebsiteCmsRestrictedPath } from '../lib/constants/cmsAccess';

interface RouteConfig {
  path: string;
  component: React.ReactElement;
  auth?: Boolean | null;
  children?: RouteConfig[];
  allowedRoles?: string[];
}

const getHomeRouteByRole = (role: string | undefined | null) => {
  if (role === AdminRole.T2F_MANAGER || role === AdminRole.KIOSK_OWNER) {
    return AppRoutes.KIOSKS;
  }

  return AppRoutes.DASHBOARD;
};

function renderRoutes(
  routes: RouteConfig[],
  role: string | undefined | null,
  email: string | undefined | null,
) {
  return routes.map(({ path, component, children, allowedRoles }) => (
    <Route
      path={path}
      key={path}
      element={
        canAccessByRole(role, allowedRoles) && (!isWebsiteCmsRestrictedPath(path) || canAccessWebsiteCms(email))
          ? component
          : <Navigate to={getHomeRouteByRole(role)} replace />
      }
    >
      {children && renderRoutes(children, role, email)}
    </Route>
  ));
}

export default function Router() {
  const currentUserRole = useSelector((state: RootState) => state.auth.role);
  const currentUserEmail = useSelector((state: RootState) => state.auth.email);

  return (
    <BrowserRouter
      future={{
        v7_relativeSplatPath: true,
      }}
    >
      <Routes>
        <Route path="/" element={<Navigate to={AppRoutes.LOGIN} replace />} />
        <Route
          path={AppRoutes.LOGIN}
          element={
            <LoginLayout>
              <LoginPage />
            </LoginLayout>
          }
        />
        <Route
          path={AppRoutes.REGISTER}
          element={
            <LoginLayout>
              <RequestLoginPage />
            </LoginLayout>
          }
        />
        <Route
          path={AppRoutes.FORGOT_PASSWORD}
          element={
            <LoginLayout>
              <ForgotPasswordPage />
            </LoginLayout>
          }
        />
        <Route element={<PrivateWrapper />}>
          <Route path={AppRoutes.HOME} element={<DashboardLayout />}>
            <Route index element={<Navigate to={getHomeRouteByRole(currentUserRole)} replace />} />
            {renderRoutes(routes, currentUserRole, currentUserEmail)}
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
